import * as React from "react";
import { createSvgIcon } from "@material-ui/core/utils";
export var iconPath = (React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M18.707 9.707L12 16.414 5.293 9.707l1.414-1.414L12 13.586l5.293-5.293 1.414 1.414z" }));
export default createSvgIcon(iconPath, "ArrowStrokeDown");
//# sourceMappingURL=ArrowStrokeDownIcon.js.map